import { uppercase } from "@src/utils/character-utils";
import Button from "../Button/Button";
import CharacterPortrait from "../CharacterPortrait/CharacterPortrait";
import "./styles/link-card.sass";
import { Link } from "@src/types/global";

interface IProps {
    link: Link;
    deleteFn: (id: string) => void;
    editFn: (id: string) => void;
}

const LinkCard = ({ link, editFn, deleteFn }: IProps) => {
    return (
        <div className="link-card">
            <span className="avatarA">
                <div className="link-card__version">
                    <span className="link-card__version__name">
                        {link.character_A_version.version_name}
                    </span>
                    <div className="link-card__version__character-name">
                        {link.character_A_version.name}
                    </div>
                </div>
                <CharacterPortrait
                    avatar={link.character_A_version.avatar}
                    size="medium"
                />
            </span>
            <span className="avatarB">
                <div className="link-card__version">
                    <span className="link-card__version__name">
                        {link.character_B_version.version_name}
                    </span>
                    <div className="link-card__version__character-name">
                        {link.character_B_version.name}
                    </div>
                </div>
                <CharacterPortrait
                    avatar={link.character_B_version.avatar}
                    size="medium"
                />
            </span>
            <div className="type">
                <p>{uppercase(link.relationship_type)}</p>
            </div>
            <div className="update">
                <Button preset="stealth" type="button" fn={editFn}>
                    Edit
                </Button>
            </div>
            <div className="delete">
                <Button preset="danger" type="button" fn={deleteFn}>
                    Delete
                </Button>
            </div>
        </div>
    );
};
export default LinkCard;
